import script from "./PremiumActive.vue?vue&type=script&setup=true&lang=js"
export * from "./PremiumActive.vue?vue&type=script&setup=true&lang=js"

import "./PremiumActive.vue?vue&type=style&index=0&id=693d7da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693d7da8"]])

export default __exports__